import { ListAppearance } from "../component/button/AppearanceDropDown";

const envVariable = (variable: string, defaultVariable: string | null = null): string => {
    return (process.env[variable] && process.env[variable] !== 'undefined' ? process.env[variable] : defaultVariable) ?? '';
}

export const isManualRegistrationEnabled = (): boolean => {
    return 'true' === envVariable('REACT_APP_ALLOW_MANUAL_REGISTRATION');
}

export const isFolderDuplicationEnabled = (): boolean => {
    return 'true' === envVariable('REACT_APP_ALLOW_FOLDER_DUPLICATION');
}

export const getExtranetLoginUrl = (): string | null => {
    const url = envVariable('REACT_APP_OAUTH_EXTRANET_BASE_URL') ?? null;
    return url ? `${url}/login` : null;
}

export const getFoldersDataViewMode = (): ListAppearance => {
    const viewMode = envVariable('REACT_APP_FOLDER_DATA_LIST', 'table');
    if (['list', 'table'].includes(viewMode)) {
        return viewMode as ListAppearance;
    }
    return 'list' as ListAppearance;
}

export default envVariable;
